import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { MFRepositories } from '@sennder/microfrontend-registry'
import { MicroFrontend } from '@sennder/microfrontend-registry/vue'
import { SharedDataType } from '@sennder/senn-node-microfrontend-interfaces'

export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationsInbox',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(MicroFrontend), {
    class: "notificationsContainer",
    repository: _unref(MFRepositories).NotificationInbox,
    app: "notifications",
    integrator: _unref(SharedDataType).SENN_TMS,
    props: undefined
  }, null, 8 /* PROPS */, ["repository", "integrator"]))
}
}

})